import Vue from 'vue'
import App from './App.vue'

// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

import axios from 'axios'
Vue.prototype.$ajax = axios;

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
